import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavigationOrder from '../shared/layout/NavigationOrder';

const Order = () => {
  const currentWorkSite = useLocation().state;

  return (
    <div>
      {/* Navigation */}
      <NavigationOrder currentWorkSite={currentWorkSite} />

      {/* Outlet SANS prop */}
      <Outlet />
    </div>
  );
};

export default Order;
